import { callables as metadataCallables } from "./metadata/callables";
import { callables as workspaceCallables } from "./workspaces/callables";
import { callables as subscriptionsCallables } from "./workspaceBilling/callables";
import { callables as enterpriseCallables } from "./enterprise/callables";
import { callables as collaborationInvitesCallables } from "./collaborationInvites/callables";

export { apiName } from "./endpoints";

export const callables = {
    ...metadataCallables,
    ...workspaceCallables,
    ...subscriptionsCallables,
    ...enterpriseCallables,
    ...collaborationInvitesCallables
};
